export const getStatusCode = (status: number): string => {
  if (!status) {
    return 'N/A'
  }
  return status.toString()
}
